import Vue from 'vue';
// import axios from 'axios';
import Buefy from 'buefy';
import VueSweetalert2 from 'vue-sweetalert2';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';
// import './store';
import store from './store';

// import '../node_modules/font-awesome';
// import '../node_modules/bulma/css/bulma.css';
// import '../node_modules/buefy/dist/buefy.css';

Vue.use(Buefy, {
  defaultIconPack: 'fas',
});
Vue.use(VueSweetalert2);
// Vue.use(axios);

router.beforeEach((to, from, next) => {
  store.setLp('lp1');
  next();
});

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
